module.exports = __webpack_public_path__ + "img/Speaker=Crystal Hunt.d4a6fc39.png";